import { render } from "./ThumbnailBoardList.vue?vue&type=template&id=7a979d58&scoped=true"
import script from "./ThumbnailBoardList.vue?vue&type=script&lang=js"
export * from "./ThumbnailBoardList.vue?vue&type=script&lang=js"

import "./ThumbnailBoardList.vue?vue&type=style&index=0&id=7a979d58&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a979d58"]])

export default __exports__